import { StatsTealiumDataLayerEmailSignupEventInterface } from 'common/module/stats/tealium/data-layer/email-signup-event.interface';
import { StatsTealiumDataLayerEventActionEnum } from 'common/module/stats/tealium/data-layer/event-action.enum';
import { StatsTealiumDataLayerEventCategoryEnum } from 'common/module/stats/tealium/data-layer/event-category.enum';
import { StatsTealiumDataLayerEventLabelEnum } from 'common/module/stats/tealium/data-layer/event-label.enum';
import { StatsTealiumDataLayerEventTypeEnum } from 'common/module/stats/tealium/data-layer/event-type.enum';
import { StatsTealiumDataLayerTealiumEventEnum } from 'common/module/stats/tealium/data-layer/tealium-event.enum';

export const StatsTealiumEmailSignupEvent = (
  email: string,
  isEmailMeChecked?: boolean
): StatsTealiumDataLayerEmailSignupEventInterface => ({
  tealium_event: StatsTealiumDataLayerTealiumEventEnum.emailSignup,
  user_email: email,
  event_category: StatsTealiumDataLayerEventCategoryEnum.productFeature,
  event_action: StatsTealiumDataLayerEventActionEnum.emailAlert,
  event_label: StatsTealiumDataLayerEventLabelEnum.signUp,
  event_type: StatsTealiumDataLayerEventTypeEnum.click,
  email_me_consent: isEmailMeChecked ? 'yes' : 'no',
});
